module.exports = __webpack_public_path__ + "static/flags/PE-8a6579550a7468d746e0f7f45b377f30.gif";